const jssStyles = theme => ({
  container: {},
})

export default jssStyles
